/* Confetes do brinde por valor (09/10).
   Sem biblioteca e sem imagem: quadradinhos criados na hora, só quando o brinde
   é liberado com o carrinho aberto, animados pelo próprio navegador (placa de
   vídeo) e removidos sozinhos em ~3,7 s. Quem usa "reduzir movimento" não vê. */
(function () {
  'use strict';
  var barra = document.querySelector('[data-brinde-barra]');
  if (!barra || !barra.animate || !window.MutationObserver) return;
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var CORES = ['#531c3f', '#8a6a7e', '#d4a63a', '#e9c46a', '#ffffff', '#b98aa5'];
  var ativo = false;

  function solta() {
    if (ativo) return;
    ativo = true;
    var w = window.innerWidth, h = window.innerHeight;
    var n = w < 600 ? 45 : 70;
    var caixa = document.createElement('div');
    caixa.setAttribute('aria-hidden', 'true');
    caixa.style.cssText = 'position:fixed;left:0;top:0;width:100%;height:100%;pointer-events:none;overflow:hidden;z-index:2147483000';
    var frag = document.createDocumentFragment();
    for (var i = 0; i < n; i++) {
      var el = document.createElement('i');
      var t = 6 + Math.random() * 6;
      var cor = CORES[Math.floor(Math.random() * CORES.length)];
      el.style.cssText = 'position:absolute;display:block;top:-16px;left:' + (Math.random() * w).toFixed(0) + 'px;' +
        'width:' + t.toFixed(1) + 'px;height:' + (t * (Math.random() < .5 ? 1 : 1.8)).toFixed(1) + 'px;' +
        'background:' + cor + ';border-radius:' + (Math.random() < .3 ? '50%' : '2px') + ';' +
        'box-shadow:0 0 0 1px rgba(0,0,0,.08);will-change:transform,opacity';
      var dx = (Math.random() - .5) * 220;
      var giro = (Math.random() < .5 ? -1 : 1) * (360 + Math.random() * 720);
      el.animate([
        { transform: 'translate3d(0,0,0) rotate(0deg)', opacity: 1 },
        { transform: 'translate3d(' + dx.toFixed(0) + 'px,' + (h * .85).toFixed(0) + 'px,0) rotate(' + giro.toFixed(0) + 'deg)', opacity: 1, offset: .8 },
        { transform: 'translate3d(' + (dx * 1.1).toFixed(0) + 'px,' + (h + 30) + 'px,0) rotate(' + giro.toFixed(0) + 'deg)', opacity: 0 }
      ], {
        duration: 1800 + Math.random() * 1400,
        delay: Math.random() * 350,
        easing: 'cubic-bezier(.25,.5,.5,1)',
        fill: 'forwards'
      });
      frag.appendChild(el);
    }
    caixa.appendChild(frag);
    document.body.appendChild(caixa);
    setTimeout(function () {
      if (caixa.parentNode) caixa.parentNode.removeChild(caixa);
      ativo = false;
    }, 3800);
  }

  /* dispara na hora em que a barra vira "ganhou", mas só com a gaveta aberta:
     quem volta ao site com o brinde já liberado não leva confete na cara */
  var tinha = barra.classList.contains('is-ganho');
  new MutationObserver(function () {
    var ganhou = barra.classList.contains('is-ganho');
    if (ganhou && !tinha) {
      var g = document.querySelector('.gaveta');
      if (g && g.classList.contains('is-aberto')) solta();
    }
    tinha = ganhou;
  }).observe(barra, { attributes: true, attributeFilter: ['class'] });
})();